import { HardHat, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Placeholder shown while the DPIA module is paused for a rebuild.
 *
 * The original DpiaListPage + ThresholdAssessmentPage are still in the
 * repo; the App.tsx router points both /dpia and /dpia/threshold here.
 * To bring them back, swap the route elements back to the real pages.
 */
export function DpiaUnderConstructionPage() {
  return (
    <div className="max-w-xl mx-auto py-16 text-center">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full
                      bg-warning-50 text-warning-500 mb-4">
        <HardHat className="w-7 h-7" aria-hidden />
      </div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">
        DPIA module — under construction
      </h1>
      <p className="text-sm text-gray-600 mb-6">
        We're reworking the Data Protection Impact Assessment tools. Watch this
        space — the threshold assessment and DPIA workflow will be back here
        once the new version is ready.
      </p>
      <Link to="/audits"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium
                       text-white bg-accent-alt-600 hover:bg-accent-alt-700 rounded-md
                       transition-colors">
        <ArrowLeft className="w-4 h-4" aria-hidden />
        Back to audits
      </Link>
    </div>
  );
}
